<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import MainLayout from "../../layout/MainLayout.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import type { IProductType } from "../../entities/product-type";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save } from "./product-type.store";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.description != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IProductType> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/product-type/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/product-type`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Descrizione" placeholder="" disabled={true} required={true} bind:value={$record.description} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <Input name="Temperatura" placeholder="" required={false} bind:value={$record.storageTemperature} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <NumberInput name="Giorni scadenza" placeholder="" required={false} bind:value={$record.bestBeforeDays} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-6">
              <FormField>
                <Textarea name="Ingredienti in etichetta" placeholder="" required={false} bind:value={$record.labelIngredients} />
              </FormField>
            </div>
            <div class="column is-6">
              <FormField>
                <Textarea name="Valori nutrizionali" placeholder="" required={false} bind:value={$record.nutritionFacts} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</MainLayout>
